module.exports = __webpack_public_path__ + "img/Screen Shot 2020-10-26 at 3.39.48 PM.b9011c20.png";